import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const AlignItemsTop = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fill={color}
          fillRule="evenodd"
          d="M1 2.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5ZM6.5 5H3v8h3.5V5ZM3 4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h3.5a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H3Zm6.5 1H13v4H9.5V5Zm-1 0a1 1 0 0 1 1-1H13a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H9.5a1 1 0 0 1-1-1V5Z"
          clipRule="evenodd"
        />
      </svg>
    )
  },
)

export default AlignItemsTop
